import { getRequest } from '..';

export function getAllActive() {
  return getRequest('/appmodule/organisation/current/active');
}
